<div class="multi-file-upload-container">
  <div class="file-input-area" [class.disabled]="disabled || readOnlyInput">
    <input
      type="file"
      id="multiFileUpload"
      (change)="onFileSelected($event)"
      [attr.accept]="accept"
      multiple
      [disabled]="disabled || readOnlyInput"
      style="display: none"
    />
    <label for="multiFileUpload" class="btn btn-primary btn-sm waves-effect waves-light">
      <i class="bi bi-plus-lg" ></i> <span tmwTranslate="tmw.common.addFile"></span>
    </label>
    <span *ngIf="!readOnlyInput" class="ms-2 text-muted" tmwTranslate="tmw.common.selectMultipleFiles"></span>
  </div>

  <ul class="file-list list-group mt-3" *ngIf="files.length > 0">
    <li class="list-group-item d-flex align-items-center" *ngFor="let localFile of files">
      <i class="ri-file-line me-2 font-size-18"></i>
      <div class="flex-grow-1">
        <div class="d-flex justify-content-between align-items-center">
          <span class="file-name text-truncate me-2" [title]="localFile.fichierName">{{ localFile.fichierName | tmwAbbreviate: 30 }}</span>
          <div class="file-actions">
            <!-- <button
              type="button"
              class="btn btn-sm btn-soft-primary ms-2"
              (click)="openFile(localFile)"
              title="{{ 'tmw.common.openFile' | tmwTranslate }}"
              *ngIf="localFile.status === 'done'"
            >
              <i class="ri-eye-line"></i>
            </button> -->
            <button
              type="button"
              class="btn btn-sm btn-danger ms-2"
              (click)="removeFile(localFile)"
              title="Supprimer"
              [disabled]="readOnlyInput"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>
        <div *ngIf="localFile.status === 'error' && localFile.errorMessage" class="text-danger font-size-12 mt-1">
          {{ localFile.errorMessage }}
        </div>
      </div>
    </li>
  </ul>
</div>
